class BlockHeadingNew {
  constructor() {
    this._init();
  }

  _init() {
    this._backButton();
    this._readMoreButton();
  }
  _readMoreButton() {
    const readMoreButton = document.querySelector('.heading-new__read-more');

    if (readMoreButton) {
      readMoreButton.addEventListener('click', () => {
        const currentSection = readMoreButton.closest('section');
        if (currentSection) {
          const nextSection = currentSection.nextElementSibling as HTMLElement;
          if (nextSection) {
            nextSection.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    }
  }

  _backButton() {
    const backButton = document.querySelector('.heading-new__back');

    if (backButton) {
      backButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.history.length > 1) {
          window.history.back();
        } else {
          const domain = window.location.hostname;
          window.location.href = `https://${domain}/actualites`;
        }
      });
    }
  }
}

export const blockHeadingNew = new BlockHeadingNew();